import { axiosPrivate } from "./axiosInstance";

export default {
  getAllCoupons() {
    return axiosPrivate.get("/warranty/dealerCoupon/200/1");
  }
};
